
import React, { useState, useEffect } from 'react'
import url from '../api/url'
import { useEmpleadoStore } from '../stores/useEmpleadoStore'
import { InfoIcon, WordIcon } from '../assets/icons'

export default function useHistorialComisiones(fromAdmin) {
    const [listaHistorial, setListaHistorial] = useState([])
    const { URL: URL_MIO, SERVIDOR } = url()
    const objLogueado = useEmpleadoStore(state => state.objLogueado)
    const [cargando, setCargando] = useState(false)
    const [show, setShow] = useState(false)
    // eslint-disable-next-line
    const [guardando, setGuardando] = useState(false)
    const [jefes, setJefes] = useState([])
    const [puesto, setPuesto] = useState('')
    // eslint-disable-next-line
    const [cargandoModal, setCargandoModal] = useState(false)
	const [buscar, setBuscar] = useState('')
	const [elementosFiltrados, setElementosFiltrados] = useState([])




    const [formComision, setFormComision] = useState({
        motivo: '',
        areas_adscripcion: '',
        fecha_salida: '',
        fecha_regreso: '',
        tipo_viatico: '',
        vehiculo_autorizado: '',
        combustible: '',
        litros: '',
        placas: '',
        puesto: '',
    })
    const [formOrigen, setFormOrigen] = useState({
        pais: '',
        estado: '',
        ciudad: '',
    })
    const [formDestino, setFormDestino] = useState({
        pais: '',
        estado: '',
        ciudad: '',
    })




    const handleClose = () => setShow(false);
    const handleShow = (id) => {
        setShow(true);
        trearInfoModal(id)
    }




    function traerHistorial() {

        if (!objLogueado.email) {
            return
        }

        setCargando(true)

        var body = new FormData()
        body.append('funcion', 'historialComisiones')
        body.append('email', objLogueado.email)
        body.append('fromAdmin', fromAdmin)

        fetch( URL_MIO, {
            method: 'post',
            body: body
        })
        .then(respuesta => respuesta.json())
        .then(datos => {
            setListaHistorial(datos)
			setElementosFiltrados(datos)
        })
        .catch(err => {
            alert('Hay problemas al traer tu historial de comisiones.')
        })
        .finally(() => setCargando(false))
    }

    function traerJefes() {
        if (!objLogueado.email) {
            return
        }

        setCargando(true)
        let body = new FormData()
        body.append('email', objLogueado.email)
        body.append('funcion', 'buscarJefesCargo')

        fetch(URL_MIO, {
            method: 'post',
            body
        })
            .then(a => a.json())
            .then(r => {
                setJefes(r)
            })
            .catch(a => {
                alert('Hubo un error al mostrar la lista de jefes, por favor intentalo nuevamente.')
            })
            .finally(() => {
                setCargando(false)
            })

    }


    function traerPuesto() {
        if (!objLogueado.email) {
            return
        }

        setCargando(true)
        let body = new FormData()
        body.append('email', objLogueado.email)
        body.append('funcion', 'puestoPersona')

        fetch(URL_MIO, {
            method: 'post',
            body
        })
            .then(a => a.json())
            .then(r => {
                setPuesto(r.puesto)
            })
            .catch(a => {
                alert('Hubo un error al mostrar tu puesto, por favor intentalo nuevamente.')
            })
            .finally(() => {
                setCargando(false)
            })

    }


    function trearInfoModal(id) {
        if (!objLogueado.email) {
            return
        }

        setCargandoModal(true)

        var body = new FormData()
        body.append('funcion', 'infoModalComision')
        body.append('id', id)

        fetch( URL_MIO, {
            method: 'post',
            body: body
        })
        .then(respuesta => respuesta.json())
        .then(datos => {
            setFormComision(datos.general)
            setFormOrigen(datos.origen)
            setFormDestino(datos.destino)
        })
        .catch(err => {
            alert('Hay problemas al traer esta comisión.')
        })
        .finally(() => setCargandoModal(false))
    }



	function convertArrayOfObjectsToCSV(array) {
		let result;

		const columnDelimiter = ',';
		const lineDelimiter = '\n';
		const keys = Object.keys(listaHistorial[0]);

		result = '';
		result += keys.join(columnDelimiter);
		result += lineDelimiter;

		array.forEach(item => {
			let ctr = 0;
			keys.forEach(key => {
				if (ctr > 0) result += columnDelimiter;

				result += item[key];

				ctr++;
			});
			result += lineDelimiter;
		});

		return result;
	}


	function downloadCSV(array) {
		const link = document.createElement('a');
		let csv = convertArrayOfObjectsToCSV(array);
		if (csv == null) return;

		const filename = 'Datos.csv';

		if (!csv.match(/^data:text\/csv/i)) {
			csv = `data:text/csv;charset=utf-8,${csv}`;
		}

		link.setAttribute('href', encodeURI(csv));
		link.setAttribute('download', filename);
		link.click();
	}


	const Export = ({ onExport }) => <button className='btn btn-outline-info' onClick={e => onExport(e.target.value)}>Descargar</button>;



    useEffect(() => {
        traerHistorial()
        if (!fromAdmin) {
			traerJefes()
        	traerPuesto()
		}
        // eslint-disable-next-line
    }, [])

	useEffect(() => {
		let a = listaHistorial.filter(
			item => item.nombre_empleado && (item.nombre_empleado.toLowerCase().includes(buscar.toLowerCase())
				|| item.motivo.toLowerCase().includes(buscar.toLowerCase()))
		);
		setElementosFiltrados(a)
		// eslint-disable-next-line
	}, [buscar])



	// tabla
    const style = {
        // paddingTop: '10px',
        // paddingBottom: '10px',
        fontSize: '15px'
    }

	const columns = [
		{
			name: 'Empleado',
			sortable: true,
            style,
			selector: row => row.nombre_empleado
		},
		{
			name: 'Motivo',
			sortable: true,
            style,
			maxWidth: '200px',
			selector: row => row.motivo
		},
		{
			name: 'Salida',
			sortable: true,
            style,
			maxWidth: '60px',
			selector: row => row.fecha_salida
		},
		{
			name: 'Regreso',
			sortable: true,
            style,
			maxWidth: '60px',
			selector: row => row.fecha_regreso
		},
		{
			name: 'Área de adscripción',
			sortable: true,
            style,
			selector: row => row.areas_adscripcion
		},
		{
			name: 'Ver',
			sortable: true,
            style,
			selector: row => row.id,
			maxWidth: '20px',
			cell: row => (
				<>
					<button className="btn btn-outline-info" onClick={() => handleShow(row.id)}>
						<InfoIcon/>
					</button>
				</>
			)
		},
		{
			name: 'Generar formato',
			sortable: true,
            style,
			selector: row => row.id,
			maxWidth: '150px',
			cell: row => (
				<>
					<a className="btn btn-outline-primary d-flex" rel="noreferrer" target="_blank" href={SERVIDOR + '/funciones/exportar_comision.php?id=' + row.id}>
						<WordIcon />
					</a>
				</>
			)
		},
	];


    return {
        listaHistorial, cargando, show, handleClose, handleShow, formComision, formDestino, formOrigen, guardando,
        setFormComision, setFormDestino, setFormOrigen, jefes, puesto, trearInfoModal,
		columns, Export, downloadCSV, elementosFiltrados, setElementosFiltrados, buscar, setBuscar
    }
}

